export default __webpack_public_path__ + "static/GA_Atlanta_downtown-skyline_shutterstock_10319672171920px-e58c7326ab2a44590ff666211173e603.jpg";